import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import classnames from 'classnames';
import { isDescendant } from '../../lib/DomUtils';
import WindowEventHelper from '../../lib/WindowEventHelper';
import { updateEditorMode, updateToolbarLeft } from '../../actions';
import { EDITOR_MODE_HTML, EDITOR_MODE_MARKDOWN, EDITOR_MODES } from '../../constants/EditorMode';
import { attachFiles } from '../../lib/Uploader';

@connect(state => ({
  editorMode: state.env.editorMode,
  toolbarLeft: state.env.toolbarLeft,
}), dispatch => ({
  handleUpdateEditorMode: mode => {
    dispatch(updateEditorMode(mode));
  },
  handleUpdateToolbarLeft: left => {
    dispatch(updateToolbarLeft(left));
  },
}))
class SimpleEditorToolbar extends Component {
  constructor (props) {
    super(props);
    this.state = {
      openAttach: false,
      openMode: false,
    };

    this.attachRoot = React.createRef();
    this.modeRoot = React.createRef();
  }

  componentDidMount () {
    WindowEventHelper.add('click', this.handleWindowClick);
    WindowEventHelper.add('resize', this.handleWindowResize);
  }

  componentWillUnmount () {
    WindowEventHelper.remove('click', this.handleWindowClick);
    WindowEventHelper.remove('resize', this.handleWindowResize);
  }

  @autobind
  handleWindowResize () {
    const { editorMode, handleUpdateToolbarLeft } = this.props;
    if (editorMode === EDITOR_MODE_HTML) {
      return;
    }
    const btnCategory = document.getElementsByClassName('btn-category')[0];
    const topToolbar = document.getElementsByClassName('mce-top-part')[0];
    if (btnCategory && topToolbar) {
      const toolbarLeft = btnCategory.getBoundingClientRect().left - 7;
      topToolbar.style.left = `${toolbarLeft}px`;
      topToolbar.style.transform = 'none';
      handleUpdateToolbarLeft(toolbarLeft);
    }
  }

  @autobind
  handleWindowClick (e) {
    if (!isDescendant(this.attachRoot.current, e.target)) {
      this.setState({
        openAttach: false,
      });
    }

    if (!isDescendant(this.modeRoot.current, e.target)) {
      this.setState({
        openMode: false,
      });
    }
  }

  @autobind
  handleToggleAttach (e) {
    this.setState({
      openAttach: !this.state.openAttach,
    });
  }

  @autobind
  handleToggleMode (e) {
    this.setState({
      openMode: !this.state.openMode,
    });
  }

  @autobind
  handleAttachImage (e) {
    const { onAttachImage } = this.props;
    attachFiles(e.target.files, onAttachImage, (e, file) => {
      alert(`'${file.name}'를 업로드 하지 못했습니다.`);
    });
    this.handleToggleAttach();
  }

  @autobind
  handleAttachFile (e) {
    const { onAttachFile } = this.props;
    attachFiles(e.target.files, onAttachFile, (e, file) => {
      alert(`'${file.name}'를 업로드 하지 못했습니다.`);
    });
    this.handleToggleAttach();
  }

  @autobind
  handleUpdateEditorMode (mode) {
    const { editorMode, handleUpdateEditorMode } = this.props;
    if (editorMode !== EDITOR_MODE_MARKDOWN && mode === EDITOR_MODE_MARKDOWN && !confirm('마크다운 모드에서는 일부 지원되지 않는 기능이 있습니다.\n전환하시겠습니까?')) {
      return;
    }
    handleUpdateEditorMode(mode);
  }

  render () {
    const { editorMode, toolbarLeft } = this.props;
    const { openAttach, openMode } = this.state;

    return (
      <div className="mce-top-part mce-container mce-stack-layout-item mce-first" style={{ left: `${toolbarLeft}px`, transform: 'none' }}>
        <div className="mce-container-body">
          <div className="mce-toolbar-grp mce-container mce-panel mce-first mce-last" hidefocus="1" tabIndex="-1" role="group">
            <div className="mce-container-body mce-stack-layout">
              <div className="mce-container mce-toolbar mce-stack-layout-item mce-first mce-last" role="toolbar">
                <div className="mce-container-body mce-flow-layout">
                  <div className="mce-container mce-flow-layout-item mce-first mce-btn-group" role="group">
                    <div>
                      <div ref={this.attachRoot} className={classnames('mce-widget mce-btn mce-menubtn mce-fixed-width mce-listbox mce-first', { 'mce-opened': openAttach })} tabIndex="-1" aria-labelledby="mceu_72" role="button" aria-label="첨부" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1" onClick={this.handleToggleAttach}>
                          <i className="mce-ico mce-i-image" /> <i className="mce-caret" />
                        </button>

                        {openAttach &&
                        <div className="mce-container mce-panel mce-floatpanel mce-menu mce-animate mce-menu-has-icons mce-fixed mce-menu-align mce-in" role="application" style={{ marginLeft: '-39px' }}>
                          <div className="mce-container-body mce-stack-layout" role="menu" style={{ width: '117px' }}>
                            <div className="mce-menu-item mce-menu-item-normal mce-stack-layout-item mce-first" tabIndex="-1" role="menuitem" aria-checked="false">
                              <i className="mce-ico mce-i-image" />&nbsp;<span className="mce-text">사진</span>
                              <input type='file' className='btn-menu-attach' multiple='multiple' accept='image/*' onChange={this.handleAttachImage} />
                            </div>
                            <div className="mce-menu-item mce-menu-item-normal mce-stack-layout-item" tabIndex="-1" role="menuitem" aria-checked="false">
                              <i className="mce-ico mce-i-file" />&nbsp;<span className="mce-text">파일</span>
                              <input type='file' className='btn-menu-attach' multiple='multiple' accept='*' onChange={this.handleAttachFile} />
                            </div>
                          </div>
                        </div>
                        }

                      </div>
                      <div className="mce-widget mce-btn mce-menubtn mce-fixed-width mce-listbox mce-btn-has-text" tabIndex="-1" aria-labelledby="mceu_73" role="button" aria-label="Formats" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1"><span className="mce-txt">제목1</span> <i className="mce-caret" /></button>
                      </div>
                      <div className="mce-widget mce-btn mce-menubtn mce-fixed-width mce-listbox mce-last mce-btn-has-text" tabIndex="-1" aria-labelledby="mceu_74" role="button" aria-label="Font Family" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1"><span className="mce-txt">본고딕</span> <i className="mce-caret" /></button>
                      </div>
                    </div>
                  </div>
                  <div className="mce-container mce-flow-layout-item mce-btn-group" role="group">
                    <div>
                      <div className="mce-widget mce-btn mce-first" tabIndex="-1" aria-pressed="false" role="button" aria-label="Bold">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-bold" /></button>
                      </div>
                      <div className="mce-widget mce-btn" tabIndex="-1" aria-pressed="false" role="button" aria-label="Italic">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-italic" /></button>
                      </div>
                      <div className="mce-widget mce-btn" tabIndex="-1" aria-pressed="false" role="button" aria-label="Underline">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-underline" /></button>
                      </div>
                      <div className="mce-widget mce-btn" tabIndex="-1" aria-pressed="false" role="button" aria-label="Strikethrough">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-strikethrough" /></button>
                      </div>
                      <div className="mce-widget mce-btn mce-forecolor mce-splitbtn mce-colorbutton" role="button" tabIndex="-1" aria-haspopup="true" aria-label="글자색">
                        <button role="presentation" hidefocus="1" type="button" tabIndex="-1"><i className="mce-ico mce-i-forecolor" /><span className="mce-preview" style={{ backgroundColor: 'rgb(51, 51, 51)' }} /></button>
                        <button type="button" className="mce-open" hidefocus="1" tabIndex="-1"><i className="mce-caret" /></button>
                      </div>
                      <div className="mce-widget mce-btn mce-hilitecolor mce-splitbtn mce-colorbutton mce-last" role="button" tabIndex="-1" aria-haspopup="true" aria-label="배경색">
                        <button role="presentation" hidefocus="1" type="button" tabIndex="-1"><i className="mce-ico mce-i-hilitecolor" /><span className="mce-preview" style={{ backgroundColor: 'rgb(255, 255, 255)' }} /></button>
                        <button type="button" className="mce-open" hidefocus="1" tabIndex="-1"><i className="mce-caret" /></button>
                      </div>
                    </div>
                  </div>
                  <div className="mce-container mce-flow-layout-item mce-btn-group" role="group">
                    <div>
                      <div className="mce-widget mce-btn mce-first" tabIndex="-1" aria-pressed="false" role="button" aria-label="Align left">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-alignleft" /></button>
                      </div>
                      <div className="mce-widget mce-btn" tabIndex="-1" aria-pressed="false" role="button" aria-label="Align center">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-aligncenter" /></button>
                      </div>
                      <div className="mce-widget mce-btn" tabIndex="-1" aria-pressed="false" role="button" aria-label="Align right">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-alignright" /></button>
                      </div>
                      <div className="mce-widget mce-btn mce-last" tabIndex="-1" aria-pressed="false" role="button" aria-label="Justify">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-alignjustify" /></button>
                      </div>
                    </div>
                  </div>
                  <div className="mce-container mce-flow-layout-item mce-btn-group" role="group">
                    <div>
                      <div className="mce-widget mce-btn mce-menubtn mce-first" tabIndex="-1" aria-labelledby="mceu_85" role="button" aria-label="List" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-kList" /></button>
                      </div>
                      <div className="mce-widget mce-btn mce-menubtn" tabIndex="-1" aria-labelledby="mceu_86" role="button" aria-label="Table" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-table" /></button>
                      </div>
                      <div className="mce-widget mce-btn" tabIndex="-1" aria-pressed="false" role="button" aria-label="Insert/edit link" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-link" /></button>
                      </div>
                      <div className="mce-widget mce-btn mce-menubtn mce-fixed-width" tabIndex="-1" aria-labelledby="mceu_88" role="button" aria-label="Horizontal line" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-hrList" /></button>
                      </div>
                      <div className="mce-widget mce-btn mce-menubtn mce-fixed-width mce-last" tabIndex="-1" aria-labelledby="mceu_89" role="button" aria-label="더보기" aria-haspopup="true">
                        <button role="presentation" type="button" tabIndex="-1"><i className="mce-ico mce-i-more" /></button>
                      </div>
                    </div>
                  </div>
                  <div className="mce-container mce-flow-layout-item mce-last mce-btn-group" role="group">
                    <div>
                      <div ref={this.modeRoot} className={classnames('mce-widget mce-btn mce-btn-has-text', { 'mce-opened': openMode })} role="button">
                        <button type="button" onClick={this.handleToggleMode}>
                          <i className="mce-txt">
                            {EDITOR_MODES.find(mode => mode.value === editorMode).text}
                          </i>
                          <i className="mce-caret">더보기</i>
                        </button>

                        {openMode &&
                        <div className="mce-container mce-panel mce-floatpanel mce-menu mce-animate mce-fixed mce-menu-align mce-in" role="application" style={{ marginLeft: '-11px' }}>
                          <div className="mce-container-body mce-stack-layout" role="menu">
                            {EDITOR_MODES.map(mode => <div key={mode.value} className="mce-menu-item mce-menu-item-normal mce-stack-layout-item " role="menuitem" onClick={e => this.handleUpdateEditorMode(mode.value)}>
                              <span className="mce-text">{mode.text}</span>
                            </div>
                            )}
                          </div>
                        </div>
                        }
                      </div>

                    </div>
                  </div>

                  <div className="dimmed_type1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SimpleEditorToolbar;
